import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropTabs extends HyperDropComponent {

  activeTabIndex: number = 0;

  onMount(): void {
    this.elements.tabLinks.forEach((link: HTMLElement, index: number) => {
      link.addEventListener('click', () => this.switchToTab(index));
    });

    this.switchToTab(0)
  }
  switchToTab(targetIndex: number) {
    this.elements.tabLinks.forEach((link: HTMLElement) => {
      link.classList.remove('active');
    });

    this.elements.tabContents.forEach((content: HTMLElement) => {
      content.classList.remove('active');
    });

    this.elements.tabLinks[targetIndex].classList.add('active');
    this.elements.tabContents[targetIndex].classList.add('active');

    this.activeTabIndex = targetIndex;
  }
}
